import { of } from "rxjs";
import { switchMap } from "rxjs/operators";
import { ofType } from "redux-observable";
import { v4 as uuid } from "uuid";
import { toastPush, toastDismiss } from "@dux/toast";

export const NOTIFICATIONS_INIT = "pss/notifications/INIT";
export const NOTIFICATIONS_ADD = "pss/notifications/ADD";
export const NOTIFICATIONS_READ = "pss/notifications/READ";
export const NOTIFICATIONS_DEHIGHLIGHT_ALL =
  "pss/notifications/DEHIGHLIGHT_ALL";

const initialState = {
  list: [],
  unreadCount: 0,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case NOTIFICATIONS_INIT:
    case NOTIFICATIONS_ADD:
      const list = [...action.payload, ...state.list];
      return {
        ...state,
        list,
        unreadCount: list.reduce((acc, n) => (n.unread ? acc + 1 : acc), 0),
      };
    case NOTIFICATIONS_READ:
      return {
        ...state,
        list: state.list.map((n) => ({ ...n, unread: false })),
        unreadCount: 0,
      };
    case NOTIFICATIONS_DEHIGHLIGHT_ALL:
      return {
        ...state,
        list: state.list.map((n) => ({ ...n, highlighted: false })),
      };
    default:
      return state;
  }
}

export function notificationsInit(notifications = []) {
  return {
    type: NOTIFICATIONS_INIT,
    payload: notifications.map((n) => ({
      ...n,
      unread: false,
      highlighted: false,
    })),
  };
}

export function notificationsAdd(notifications) {
  return {
    type: NOTIFICATIONS_ADD,
    payload: notifications.map((n) => ({
      ...n,
      unread: true,
      highlighted: true,
    })),
  };
}

export function notificationsAddSimple(data) {
  return notificationsAdd([
    {
      id: uuid(),
      timestamp: Date.now(),
      ...data,
    },
  ]);
}

export function notificationsRead(notifications) {
  return { type: NOTIFICATIONS_READ, payload: notifications };
}

export function notificationsDehighlightAll() {
  return { type: NOTIFICATIONS_DEHIGHLIGHT_ALL };
}

function pushToastsEpic(action$) {
  return action$.pipe(
    ofType(NOTIFICATIONS_ADD),
    switchMap(({ payload }) => {
      return of(...payload.map((n) => toastPush(n)));
    })
  );
}

function dismissToastsEpic(action$) {
  return action$.pipe(
    ofType(NOTIFICATIONS_READ),
    switchMap(({ payload }) => {
      return of(...payload.map((n) => toastDismiss(n.id)));
    })
  );
}

export const notificationsEpics = [pushToastsEpic, dismissToastsEpic];
